module.exports = __webpack_public_path__ + "img/loginAvatar.ed227b9e.png";